import { ListTicketViewRef } from 'app/pages/NewAccount/types';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { TAB_ORDER_MANAGEMENT } from '..';
import useListOrder from '../useListOrder';
import ListOrderLayout from '../ListOrderLayout';
import { ListOPrderManagementViewProps } from './ListOrderSuccess';

const ListOrderPending = forwardRef<
  ListTicketViewRef,
  ListOPrderManagementViewProps
>(({ activeKeyTab, loading, setLoading }, ref) => {
  const isActiveCurrentTab =
    activeKeyTab === TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN;
  const [isDisplayData, setIsDisplayData] = useState(isActiveCurrentTab);

  const { listOrder, paginator, search, optionsGetListOrder } = useListOrder({
    orderState: 'paymentPending',
    isActiveTab: isActiveCurrentTab,
    setLoading,
    onFinally: () => {
      setIsDisplayData(true);
    },
  });
  useImperativeHandle(ref, () => {
    return {
      search,
      getCurrentSearchOpt: () => optionsGetListOrder,
    };
  });

  useEffect(() => {
    if (!isActiveCurrentTab) setIsDisplayData(false);
  }, [isActiveCurrentTab]);

  return (
    <ListOrderLayout
      loading={loading}
      paginator={paginator}
      listOrder={isDisplayData ? listOrder || [] : []}
      search={search}
      getCurrentSearchOpt={() => optionsGetListOrder}
      orderState={activeKeyTab}
      setIsLoading={setLoading}
      activeKeyTab={activeKeyTab}
    />
  );
});

export default ListOrderPending;
